/**
 * HotelLogo — SVG ufficiale Hotel Aurora Duino (versione rev)
 * Monogramma HA puro: doppia traversa, stelle, senza testo
 * Usa currentColor per adattarsi a navbar trasparente/scrollata
 */
export default function HotelLogo({ className = "", style = {} }) {
  return (
    <svg
      id="Livello_1"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 566.93 566.93"
      className={className}
      style={style}
      aria-label="Hotel Aurora Duino"
      role="img"
    >
      {/* ─── Stelle ─── */}
      <g>
        <path fill="currentColor" stroke="currentColor" d="M429.61,468.06c.23.13.5.11.73,0h0l6.39-3.84,6.5,3.66c.23.13.5.13.73,0s.36-.37.36-.65l-.13-7.46,6.42-3.79h0c.23-.13.36-.37.36-.63s-.15-.5-.37-.63l-6.52-3.62-.08-7.46c0-.26-.15-.5-.37-.63-.23-.13-.5-.13-.73,0q-.15.09,0,0l-6.39,3.84-6.5-3.66c-.23-.13-.5-.13-.73,0s-.36.37-.36.65l.13,7.46-6.42,3.79h0c-.23.13-.36.37-.36.63s.15.5.37.63l6.52,3.62.08,7.46c0,.26.15.5.37.63Z"/>
        <path fill="currentColor" stroke="currentColor" d="M453.29,507.8c.23.13.5.13.73,0h0l6.39-3.84,6.5,3.66c.23.13.52.13.73,0,.23-.13.37-.37.36-.65l-.13-7.46,6.42-3.79h0c.23-.13.36-.37.36-.63s-.15-.5-.37-.63l-6.52-3.62-.08-7.46c0-.26-.15-.5-.37-.63-.23-.13-.5-.13-.73,0h0l-6.39,3.84-6.5-3.66c-.23-.13-.5-.13-.73,0s-.36.37-.36.65l.13,7.46-6.42,3.79h0c-.23.13-.36.37-.36.65,0,.26.15.5.37.63l6.52,3.62.08,7.46c0,.26.15.5.37.63v-.02Z"/>
        <path fill="currentColor" stroke="currentColor" d="M477,547.58c.23.13.5.13.73,0h0l6.39-3.84,6.5,3.66c.23.13.5.13.73,0s.36-.39.36-.65l-.13-7.46,6.42-3.79h0c.23-.13.36-.37.36-.63s-.15-.5-.37-.63l-6.52-3.62-.06-7.46c0-.26-.15-.5-.39-.63-.23-.13-.5-.11-.73,0h0l-6.39,3.84-6.5-3.66c-.23-.13-.5-.13-.74,0-.23.13-.36.37-.36.65l.13,7.46-6.42,3.79h0c-.23.13-.36.37-.36.63s.15.5.37.63l6.52,3.62.08,7.46c0,.26.15.5.37.63h.02Z"/>
      </g>

      {/* ─── Monogramma HA ─── */}
      {/* Verticale sinistra H */}
      <line fill="none" stroke="currentColor" strokeWidth="10" x1="39.27" y1="548" x2="39.27" y2="16"/>
      {/* Verticale destra H / gamba sx A */}
      <line fill="none" stroke="currentColor" strokeWidth="10" x1="224.42" y1="548" x2="224.42" y2="16"/>
      {/* Diagonale A */}
      <line fill="none" stroke="currentColor" strokeWidth="10" x1="225.73" y1="20.5" x2="545.82" y2="546.06"/>
      {/* Traversa doppia H */}
      <line fill="none" stroke="currentColor" strokeWidth="5" x1="39.27" y1="251.18" x2="224.42" y2="251.18"/>
      <line fill="none" stroke="currentColor" strokeWidth="5" x1="39.27" y1="254.85" x2="224.42" y2="254.85"/>
    </svg>
  );
}
